/* ==========================================================================
   Circle D Specialties — Support knowledge base + answer widget
   Client-side retrieval over the KB corpus. No backend, no API key, works
   when Front is offline. See knowledge-base/PLAN.md §5.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-cds-support]');
  if (!root) return;

  var dataEl = document.getElementById('cds-kb-data');
  if (!dataEl) return;

  var KB;
  try {
    KB = JSON.parse(dataEl.textContent);
  } catch (e) {
    return; // Static content is already rendered; degrade to browse-only.
  }

  var ARTICLES = (KB.articles || []).filter(function (a) { return a.status === 'live'; });
  if (!ARTICLES.length) return;

  var SYNONYMS = KB.synonyms || {};
  var BRAND = KB.brand || {};

  /* ---------- Text utilities ---------------------------------------------- */

  var STOP = ('a an the is are was were be been being do does did doing have has had ' +
    'i my me we our you your it its this that these those of in on at to for with ' +
    'from by about as if then than so and or but not no can could would should will ' +
    'just get got please help need want thanks hi hello hey there what how why when ' +
    'where which who whom does do am pls').split(' ');
  var STOPSET = Object.create(null);
  STOP.forEach(function (w) { STOPSET[w] = 1; });

  function normalize(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[‘’]/g, "'")
      .replace(/[“”]/g, '"')
      .replace(/[^a-z0-9'\-\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function tokenize(s) {
    var raw = normalize(s).split(' ');
    var out = [];
    for (var i = 0; i < raw.length; i++) {
      var t = raw[i].replace(/^-+|-+$/g, '');
      if (!t || t.length < 2) continue;
      if (STOPSET[t]) continue;
      out.push(stem(t));
    }
    return out;
  }

  // Deliberately conservative stemmer — aggressive stemming hurts a domain
  // vocabulary this specific (stall/stalling, disk/disks, converter/converters).
  function stem(t) {
    if (t.length > 4 && /ies$/.test(t)) return t.slice(0, -3) + 'y';
    if (t.length > 4 && /(ses|xes|zes|ches|shes)$/.test(t)) return t.slice(0, -2);
    if (t.length > 3 && /s$/.test(t) && !/ss$/.test(t)) return t.slice(0, -1);
    if (t.length > 5 && /ing$/.test(t)) return t.slice(0, -3);
    if (t.length > 4 && /ed$/.test(t)) return t.slice(0, -2);
    return t;
  }

  // Build the synonym expansion map both directions, stemmed.
  var SYN = Object.create(null);
  function addSyn(from, to) {
    var k = stem(normalize(from).replace(/\s+/g, ''));
    if (!SYN[k]) SYN[k] = [];
    var v = tokenize(to);
    for (var i = 0; i < v.length; i++) if (SYN[k].indexOf(v[i]) < 0) SYN[k].push(v[i]);
  }
  Object.keys(SYNONYMS).forEach(function (key) {
    var list = SYNONYMS[key] || [];
    list.forEach(function (alt) {
      addSyn(key, alt);
      addSyn(alt, key);
      // Multi-word alternates also register their first token.
      tokenize(alt).forEach(function (t) { addSyn(t, key); });
    });
  });

  // Synonyms are added at a fraction of the weight of the user's own words, and
  // near-ubiquitous terms are not expanded at all. Expanding "converter" into
  // four corpus-wide synonyms otherwise drowns the one discriminating word in
  // the query ("ship", "cost") and the wrong article wins.
  function expandWeighted(base) {
    var out = [], seen = Object.create(null);
    for (var i = 0; i < base.length; i++) {
      if (!seen[base[i]]) { seen[base[i]] = 1; out.push({ t: base[i], w: 1 }); }
    }
    for (var j = 0; j < base.length; j++) {
      if ((df[base[j]] || 0) / N > 0.34) continue;
      var syn = SYN[base[j]];
      if (!syn) continue;
      for (var k = 0; k < syn.length; k++) {
        if (seen[syn[k]]) continue;
        seen[syn[k]] = 1;
        out.push({ t: syn[k], w: 0.4 });
      }
    }
    return out;
  }

  /* ---------- Index -------------------------------------------------------- */

  var FIELD_WEIGHT = { question: 3.0, aliases: 2.5, keywords: 2.0, answer: 1.0 };
  var docs = [];
  var df = Object.create(null);

  ARTICLES.forEach(function (a) {
    var qTokens = tokenize(a.question);
    var fields = {
      question: qTokens,
      aliases: tokenize((a.aliases || []).join(' ')),
      keywords: tokenize((a.keywords || []).join(' ')),
      answer: tokenize((a.answer_short || '') + ' ' + (a.answer || ''))
    };
    var tf = Object.create(null);
    var len = 0;
    Object.keys(fields).forEach(function (f) {
      var w = FIELD_WEIGHT[f];
      fields[f].forEach(function (t) {
        tf[t] = (tf[t] || 0) + w;
        len += w;
      });
    });
    var seen = Object.create(null);
    Object.keys(tf).forEach(function (t) {
      if (!seen[t]) { df[t] = (df[t] || 0) + 1; seen[t] = 1; }
    });
    var qset = Object.create(null);
    qTokens.forEach(function (t) { qset[t] = 1; });
    docs.push({
      article: a, tf: tf, len: len,
      qset: qset, qLen: qTokens.length,
      nQuestion: normalize(a.question),
      nAliases: (a.aliases || []).map(normalize)
    });
  });

  var N = docs.length;
  var AVGLEN = docs.reduce(function (s, d) { return s + d.len; }, 0) / (N || 1);
  var K1 = 1.4, B = 0.72;

  function idf(t) {
    var n = df[t] || 0;
    return Math.log(1 + (N - n + 0.5) / (n + 0.5));
  }

  function scoreDocs(weighted, base) {
    var out = [];
    for (var i = 0; i < docs.length; i++) {
      var d = docs[i], s = 0;
      for (var j = 0; j < weighted.length; j++) {
        var f = d.tf[weighted[j].t];
        if (!f) continue;
        s += weighted[j].w * idf(weighted[j].t) *
             (f * (K1 + 1)) / (f + K1 * (1 - B + B * d.len / AVGLEN));
      }
      if (s <= 0) continue;
      // Coverage is measured over the user's OWN words only — counting
      // synonym hits here is what let confidence exceed 1.
      var cov = 0;
      for (var k = 0; k < base.length; k++) if (d.tf[base[k]]) cov++;
      out.push({ article: d.article, doc: d, raw: s, coverage: base.length ? cov / base.length : 0 });
    }
    return out;
  }

  // A question typed almost verbatim should win outright. Without this,
  // "why do I need a billet front" ranks below a neighbouring billet article
  // purely on term frequency.
  function phraseBoost(d, nq, base) {
    if (!nq) return 1;
    if (d.nQuestion === nq) return 3.2;
    for (var i = 0; i < d.nAliases.length; i++) if (d.nAliases[i] === nq) return 3.0;
    if (d.nQuestion.indexOf(nq) >= 0 || nq.indexOf(d.nQuestion) >= 0) return 2.2;
    for (var j = 0; j < d.nAliases.length; j++) {
      var al = d.nAliases[j];
      if (al.length > 6 && (nq.indexOf(al) >= 0 || al.indexOf(nq) >= 0)) return 2.0;
    }
    var hit = 0;
    for (var k = 0; k < base.length; k++) if (d.qset[base[k]]) hit++;
    var ov = base.length ? hit / base.length : 0;   // how much of the query the title covers
    var qcov = d.qLen ? hit / d.qLen : 0;           // and how much of the title the query covers
    return 1 + ov * 0.8 + qcov * 0.5;
  }

  var PARTNO = /\b\d{2}[a-z]?[-\s]?\d{2}[a-z]?[-\s]?\d{2}(?:[-\s]?\d[a-z])?\b/i;

  function search(q) {
    var base = tokenize(q);
    if (!base.length) return { results: [], confidence: 0 };

    var nq = normalize(q);
    var results = scoreDocs(expandWeighted(base), base);

    for (var i = 0; i < results.length; i++) {
      var r = results[i];
      r.score = r.raw * phraseBoost(r.doc, nq, base) * (0.6 + 0.4 * r.coverage);
    }
    results.sort(function (a, b) { return b.score - a.score; });

    // Part-number fast path — a decode question is unmistakable and specific.
    if (PARTNO.test(q)) {
      var decode = ARTICLES.filter(function (a) { return a.id === 'part-number-decode'; })[0];
      if (decode) {
        results = results.filter(function (x) { return x.article.id !== 'part-number-decode'; });
        results.unshift({
          article: decode, score: 999, coverage: 1,
          partNumber: (q.match(PARTNO) || [])[0]
        });
      }
    }

    if (!results.length) return { results: [], confidence: 0 };

    var top = results[0];
    if (top.score >= 999) return { results: results, confidence: 1 };

    // Confidence is "did we match what they actually typed, and is the winner
    // clearly the winner" — the two things that matter for the G4 hand-off.
    var second = results[1];
    var margin = second && top.score > 0 ? (top.score - second.score) / top.score : 1;
    var conf = Math.min(1, 0.7 * top.coverage + 0.3 * Math.min(1, margin * 3));

    return { results: results, confidence: conf };
  }

  /* ---------- Tiny markdown renderer -------------------------------------- */

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function inline(s) {
    return esc(s)
      .replace(/`([^`]+)`/g, '<code>$1</code>')
      .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
      .replace(/\*([^*]+)\*/g, '<em>$1</em>');
  }

  function render(md) {
    var blocks = String(md || '').split(/\n\n+/);
    var html = '';
    blocks.forEach(function (blk) {
      var lines = blk.split('\n');
      var isUl = lines.every(function (l) { return /^\s*-\s+/.test(l); });
      var isOl = lines.every(function (l) { return /^\s*\d+\.\s+/.test(l); });
      if (isUl && lines.length) {
        html += '<ul>' + lines.map(function (l) {
          return '<li>' + inline(l.replace(/^\s*-\s+/, '')) + '</li>';
        }).join('') + '</ul>';
      } else if (isOl && lines.length) {
        html += '<ol>' + lines.map(function (l) {
          return '<li>' + inline(l.replace(/^\s*\d+\.\s+/, '')) + '</li>';
        }).join('') + '</ol>';
      } else {
        html += '<p>' + lines.map(inline).join('<br>') + '</p>';
      }
    });
    return html;
  }

  /* ---------- Icons -------------------------------------------------------- */

  var ICON = {
    ext: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 17 17 7M9 7h8v8"/></svg>',
    chev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>'
  };

  /* ---------- Hand-off routing -------------------------------------------- */

  var HANDOFF_URL = {
    'spec-form': '/pages/ask-circled',
    'service-form': '/apps/service/converter-service',
    'order-status': '/pages/check-order-status',
    'dealer': '/pages/dealer-application-form',
    'product-page': '/collections/all',
    'specialist': null // opens the contact routes
  };

  /* ---------- DOM ---------------------------------------------------------- */

  var input = root.querySelector('[data-sup-input]');
  var form = root.querySelector('[data-sup-form]');
  var clearBtn = root.querySelector('[data-sup-clear]');
  var answerEl = root.querySelector('[data-sup-answer]');
  var liveRegion = root.querySelector('[data-sup-live]');

  function setState(querying, answering) {
    root.classList.toggle('is-querying', !!querying);
    root.classList.toggle('is-answering', !!answering);
  }

  function announce(msg) {
    if (liveRegion) liveRegion.textContent = msg;
  }

  function contactRoutesHTML() {
    return '' +
      '<div class="cds-sup__links">' +
        '<a class="cds-sup__link" href="#cds-sup-contact" data-sup-scroll>Contact options ' + ICON.ext + '</a>' +
        '<a class="cds-sup__link" href="mailto:' + esc(BRAND.sales_email || '') + '">Email sales ' + ICON.ext + '</a>' +
        (BRAND.phone ? '<a class="cds-sup__link" href="tel:' + esc(String(BRAND.phone).replace(/[^\d+]/g, '')) + '">Call ' + esc(BRAND.phone) + ' ' + ICON.ext + '</a>' : '') +
      '</div>';
  }

  function handoffHTML(h) {
    if (!h) return '';
    var url = HANDOFF_URL[h.type];
    var inner =
      '<div class="cds-sup__handoff-txt">' +
        '<p class="cds-sup__handoff-label">' + esc(h.label) + '</p>' +
        (h.note ? '<p class="cds-sup__handoff-note">' + esc(h.note) + '</p>' : '') +
      '</div>';
    if (url) {
      return '<div class="cds-sup__handoff">' + inner +
        '<a class="cds-sup__handoff-btn" href="' + esc(url) + '">Go ' + ICON.ext + '</a></div>';
    }
    return '<div class="cds-sup__handoff">' + inner +
      '<button type="button" class="cds-sup__handoff-btn" data-sup-specialist>Talk to us</button></div>';
  }

  function linksHTML(links) {
    if (!links || !links.length) return '';
    return '<div class="cds-sup__links">' + links.map(function (l) {
      var href = l.url;
      if (href && href.charAt(0) === '#') {
        return '<button type="button" class="cds-sup__link" data-sup-jump="' + esc(href.slice(1)) + '">' +
          esc(l.label) + ' ' + ICON.ext + '</button>';
      }
      return '<a class="cds-sup__link" href="' + esc(href) + '">' + esc(l.label) + ' ' + ICON.ext + '</a>';
    }).join('') + '</div>';
  }

  function answerHTML(hit, near, others, partNumber) {
    var a = hit.article;
    var badge = near
      ? '<span class="cds-sup__badge cds-sup__badge--near">Closest match</span>'
      : '<span class="cds-sup__badge">Answer</span>';

    var pnNote = partNumber
      ? '<p class="cds-sup__short" style="margin-top:10px"><strong>You asked about ' +
        esc(String(partNumber).toUpperCase()) + '.</strong> Send that number and the serial ' +
        'to a specialist and we\'ll give you the exact spec for your combination.</p>'
      : '';

    var also = others && others.length
      ? '<div class="cds-sup__also"><p class="cds-sup__also-h">Related</p><ul class="cds-sup__also-list">' +
        others.map(function (o) {
          return '<li><button type="button" data-sup-jump="' + esc(o.article.id) + '">' +
            esc(o.article.question) + '</button></li>';
        }).join('') + '</ul></div>'
      : '';

    return '<article class="cds-sup__card">' +
      '<div class="cds-sup__cardtop">' + badge + '</div>' +
      '<h2 class="cds-sup__q">' + esc(a.question) + '</h2>' +
      '<p class="cds-sup__short">' + inline(a.answer_short) + '</p>' +
      pnNote +
      '<div class="cds-sup__body" data-sup-full hidden>' + render(a.answer) + '</div>' +
      '<button type="button" class="cds-sup__more" data-sup-more aria-expanded="false">' +
        '<span data-sup-more-label>Read the full answer</span>' + ICON.chev +
      '</button>' +
      linksHTML(a.links) +
      handoffHTML(a.handoff) +
      also +
      '</article>';
  }

  function noAnswerHTML(q) {
    return '<article class="cds-sup__card cds-sup__none">' +
      '<div class="cds-sup__cardtop"><span class="cds-sup__badge cds-sup__badge--near">No confident match</span></div>' +
      '<h2 class="cds-sup__q">We don\'t have a good answer for that one</h2>' +
      '<p class="cds-sup__short">Rather than guess at it, let\'s put you in front of someone who builds these ' +
        'for a living. A specialist will get you a straight answer.</p>' +
      '<div class="cds-sup__body" style="margin-top:16px;padding-top:16px">' +
        '<p>If your question is about <strong>which converter to buy</strong>, the spec form is the fastest ' +
        'route — it captures everything a builder needs to answer you properly the first time.</p>' +
      '</div>' +
      '<div class="cds-sup__handoff">' +
        '<div class="cds-sup__handoff-txt">' +
          '<p class="cds-sup__handoff-label">Have us spec it</p>' +
          '<p class="cds-sup__handoff-note">About five minutes. Read by a real builder. No charge.</p>' +
        '</div>' +
        '<a class="cds-sup__handoff-btn" href="/pages/ask-circled">Start ' + ICON.ext + '</a>' +
      '</div>' +
      contactRoutesHTML() +
      '</article>';
  }

  /* ---------- Query handling ---------------------------------------------- */

  var CONF_LOW = 0.18;
  var CONF_OK = 0.35;
  var lastQuery = '';

  function runQuery(q, opts) {
    opts = opts || {};
    q = String(q || '').trim();
    lastQuery = q;

    if (!q) {
      setState(false, false);
      answerEl.innerHTML = '';
      return;
    }

    var res = search(q);
    setState(true, true);

    if (!res.results.length || res.confidence < CONF_LOW) {
      answerEl.innerHTML = noAnswerHTML(q);
      announce('No confident match found. Contact options shown.');
    } else {
      var near = res.confidence < CONF_OK;
      var top = res.results[0];
      var others = res.results.slice(1, 4);
      answerEl.innerHTML = answerHTML(top, near, others, top.partNumber);
      announce((near ? 'Closest match: ' : 'Answer: ') + top.article.question);
    }

    if (opts.scroll !== false) {
      answerEl.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'nearest' });
    }
  }

  function prefersReduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  var debounce;
  if (input) {
    input.addEventListener('input', function () {
      clearTimeout(debounce);
      var v = input.value;
      root.classList.toggle('is-querying', !!v.trim());
      if (!v.trim()) { setState(false, false); answerEl.innerHTML = ''; return; }
      debounce = setTimeout(function () { runQuery(v, { scroll: false }); }, 260);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        input.value = '';
        setState(false, false);
        answerEl.innerHTML = '';
      }
    });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearTimeout(debounce);
      runQuery(input ? input.value : '');
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      input.focus();
      setState(false, false);
      answerEl.innerHTML = '';
    });
  }

  /* ---------- Delegated interactions -------------------------------------- */

  root.addEventListener('click', function (e) {
    var t = e.target;

    // Starter chips
    var chip = t.closest && t.closest('[data-sup-chip]');
    if (chip) {
      e.preventDefault();
      if (input) { input.value = chip.getAttribute('data-sup-chip'); input.focus(); }
      runQuery(chip.getAttribute('data-sup-chip'));
      return;
    }

    // Expand full answer
    var more = t.closest && t.closest('[data-sup-more]');
    if (more) {
      var card = more.closest('.cds-sup__card');
      var full = card && card.querySelector('[data-sup-full]');
      if (!full) return;
      var open = more.getAttribute('aria-expanded') === 'true';
      full.hidden = open;
      more.setAttribute('aria-expanded', open ? 'false' : 'true');
      var label = more.querySelector('[data-sup-more-label]');
      if (label) label.textContent = open ? 'Read the full answer' : 'Show less';
      return;
    }

    // Jump to an article in the browse list
    var jump = t.closest && t.closest('[data-sup-jump]');
    if (jump) {
      e.preventDefault();
      openArticle(jump.getAttribute('data-sup-jump'), true);
      return;
    }

    // Category card → scroll to its block
    var cat = t.closest && t.closest('[data-sup-cat]');
    if (cat) {
      e.preventDefault();
      var target = document.getElementById('cat-' + cat.getAttribute('data-sup-cat'));
      if (target) {
        target.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'start' });
        var h = target.querySelector('h3');
        if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
      }
      return;
    }

    // Accordion
    var trig = t.closest && t.closest('[data-sup-trigger]');
    if (trig) {
      var item = trig.closest('.cds-sup__item');
      var isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      trig.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      return;
    }

    // Smooth-scroll helper
    var sc = t.closest && t.closest('[data-sup-scroll]');
    if (sc) {
      e.preventDefault();
      var el = document.querySelector(sc.getAttribute('href'));
      if (el) el.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'start' });
      return;
    }

    // Specialist hand-off — chat if Front is up, otherwise the contact rail.
    var spec = t.closest && t.closest('[data-sup-specialist]');
    if (spec) {
      e.preventDefault();
      openSpecialist();
      return;
    }
  });

  function openArticle(id, scroll) {
    var item = document.getElementById('a-' + id);
    if (!item) return;
    item.classList.add('is-open', 'is-target');
    var trig = item.querySelector('[data-sup-trigger]');
    if (trig) trig.setAttribute('aria-expanded', 'true');
    if (scroll) {
      item.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'center' });
      if (trig) { trig.setAttribute('tabindex', '-1'); trig.focus({ preventScroll: true }); }
    }
    setTimeout(function () { item.classList.remove('is-target'); }, 2400);
  }

  /* ---------- Front chat hand-off ----------------------------------------- */
  /* Front hides the widget outside the workspace's online hours and
     FrontChat('show') silently no-ops. Never present chat as the only route —
     verify it actually opened, and fall back to the contact rail if not. */

  function openSpecialist() {
    var rail = document.getElementById('cds-sup-contact');
    if (typeof window.FrontChat === 'function') {
      try {
        window.FrontChat('show');
        setTimeout(function () {
          var f = document.getElementById('front-chat-iframe');
          var live = f && f.getBoundingClientRect().width > 0 && f.getBoundingClientRect().height > 0;
          if (!live) fallbackToRail(rail);
        }, 700);
        return;
      } catch (err) { /* fall through */ }
    }
    fallbackToRail(rail);
  }

  function fallbackToRail(rail) {
    var chatRoute = root.querySelector('[data-sup-chat-route]');
    if (chatRoute) {
      chatRoute.classList.add('is-off');
      var b = chatRoute.querySelector('.cds-sup__route-b');
      if (b) b.textContent = 'Offline right now — email or call and we\'ll pick it up.';
    }
    if (rail) rail.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'start' });
    announce('Live chat is offline. Email and phone options shown.');
  }

  /* ---------- Deep linking ------------------------------------------------- */

  function handleHash() {
    var h = (location.hash || '').replace(/^#/, '');
    if (!h) return;
    if (h.indexOf('q=') === 0) {
      var q = decodeURIComponent(h.slice(2).replace(/\+/g, ' '));
      if (input) input.value = q;
      runQuery(q);
      return;
    }
    // Accept both forms: the DOM id we render (#a-datalog-guide, which the
    // browser also jumps to natively with JS off) and the bare article id
    // (#datalog-guide) used by in-article cross-links. openArticle() adds the
    // prefix itself, so strip it here or the lookup becomes a-a-datalog-guide.
    var id = h.indexOf('a-') === 0 ? h.slice(2) : h;
    if (document.getElementById('a-' + id)) openArticle(id, true);
  }

  window.addEventListener('hashchange', handleHash);
  handleHash();

  /* ---------- Optional LLM path (dormant) ---------------------------------- */
  /* When a future endpoint is configured as window.CDS_KB_LLM = {endpoint},
     the top retrieved articles become grounding context for a generated
     answer. Nothing on the shipped page depends on this existing. */
  window.CDS_KB = {
    search: search,
    articles: ARTICLES,
    ask: function (q) { runQuery(q); },
    version: KB.version
  };
})();
